/**
 * 获取当前社区ID
 */
export function getCommunityId() {
  const communityId = localStorage.getItem('communityId') || sessionStorage.getItem('communityId')
  return communityId || ''
}

/**
 * 设置社区ID
 */
export function setCommunityId(communityId) {
  localStorage.setItem('communityId', communityId)
  sessionStorage.setItem('communityId', communityId)
}

/**
 * 清除社区ID
 */
export function clearCommunityId() {
  localStorage.removeItem('communityId')
  sessionStorage.removeItem('communityId')
}